<style>
  .image-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    /* position: relative; */
    background: rgba(98, 98, 98, 0.4);
    min-height: 100%;
  }
  .close-btn {
    border-radius: 50%;
    background: rgb(0, 0, 0);
    color: white;
    height: 20px;
    width: 20px;
    display: flex;
    text-align: center;
    justify-content: center;
    align-items: center;
    font-weight: 600;
    position: absolute;
    /* place on top-right of img */
    cursor: pointer;
  }
  .isArray-Wrapper {
    flex-direction: column;

  }
</style>
<script>
  import GeneralImg from "../img/GeneralImg.svelte"
  export let id = null
  export let height = 500
  export let buttonHtml = "Show Ads"
  let imgShow = false
</script>
<button class="normal" on:click={() => { imgShow = true }}>
  {@html buttonHtml}
</button>
{#if imgShow}
  <div class="full-screen image-wrapper {Array.isArray(id) ? 'isArray-Wrapper' : ''}" on:click={() => imgShow = false}>
    <div class="close-btn" style="top: calc(50% - {height * 9 / 16}px); left: calc(50% - {height}px);">x</div>
     {#if Array.isArray(id) === true && imgShow}
      {#each id as individualId}
        <div>
          <GeneralImg id={individualId} {height} text=""/>
        </div>
      {/each}
    {:else}
      <GeneralImg {id} {height} text=""/>
    {/if}
  </div>
{/if}